import { convertArrayToMap } from "@/utils/json";

export enum LANGUAGES {
  AUTO = "auto",
  ENGLISH = "en_US",
  ENGLISH_UK = "en_UK",
  ENGLISH_AUSTRALIA = "en_AU",
  ENGLISH_INDIA = "en_IN",
  ENGLISH_SCOTLAND = "en_SCOTT",
  SPANISH = "es_ES",
  SPANISH_MEXICO = "es_MX",
  FRENCH = "fr_FR",
  GERMAN = "de_DE",
  ITALIAN = "it_IT",
  PORTUGUESE = "pt_BR",
  PORTUGUESE_PORTUGAL = "pt_PT",
  HINDI = "hi_IN",
  TAMIL = "ta_IN",
  POLISH = "pl_PL",
  JAPANESE = "ja_JP",
  KOREAN = "ko_KR",
  CHINESE_SIMPLIFIED = "zh_CN",
  CHINESE_CANTONESE = "zh_HK",
  DUTCH = "nl_NL",
  ARABIC = "ar_SA",
  BENGALI = "bn_IN",
  FINNISH = "fi_FI",
  RUSSIAN = "ru_RU",
  TURKISH = "tr_TR",
  VIETNAMESE = "vi_VN",
  DANISH = "da_DK",
  INDONESIAN = "id_ID",
  ROMANIAN = "ro_RO",
  NORWEGIAN = "nb_NO",
  NORWEGIAN_NORWAY = "no_NO",
  UKRAINIAN = "uk_UA",
  FRENCH_CANADA = "fr_CA",
  GERMAN_SWITZERLAND = "de_CH",
  CHINESE_TAIWAN = "zh_TW",
  SLOVAK_SLOVAKIA = "sk_SK",
  BULGARIAN_BULGARIA = "bg_BG",
  SWEDISH_SWEDEN = "sv_SE",
  CROATIAN_CROATIA = "hr_HR",
  GREEK_GREECE = "el_GR",
  KANNADA = "kn_IN",
  URDU = "ur_PK",
  GUJARATI = "gu_IN",
  MALAYALAM = "ml_IN",
  PUNJABI = "pa_IN",
  CZECH_CZECHIA = "cs_CZ",
  MALAY_MALAYSIA = "ms_MY",
  HEBREW = "he_IL",
  MARATHI = "mr_IN",
  TELUGU = "te_IN",
  THAI_THAILAND = "th_TH",
  HUNGARIAN = "hu_HU",
  FILIPINO_PHILIPPINES = "tl_PH",
  ESTONIAN_ESTONIA = "et_EE",
  HEBREW_ISRAEL = "iw_IL",
  LATVIAN_LATVIA = "lv_LV",
  LITHUANIAN_LITHUANIA = "lt_LT",
  SERBIAN_SERBIA = "sr_RS",
  SLOVENIAN_SLOVENIA = "sl_SI",
  SWAHILI_KENYA = "sw_KE"
}

type LanguageData = {
  language: LANGUAGES;
  name: string;
  flag: string;
};

export const LanguageData: LanguageData[] = [
  {
    language: LANGUAGES.ENGLISH,
    name: "English (US & Canada)",
    flag: "us-canada.svg"
  },
  {
    language: LANGUAGES.ENGLISH_UK,
    name: "English (UK)",
    flag: "uk.svg"
  },
  {
    language: LANGUAGES.ENGLISH_AUSTRALIA,
    name: "English (Australia)",
    flag: "australia.svg"
  },
  {
    language: LANGUAGES.ENGLISH_INDIA,
    name: "English (India)",
    flag: "india.svg"
  },
  {
    language: LANGUAGES.ENGLISH_SCOTLAND,
    name: "English (Scotland)",
    flag: "scotland.svg"
  },
  {
    language: LANGUAGES.SPANISH,
    name: "Spanish (Spain)",
    flag: "spain.png"
  },
  {
    language: LANGUAGES.SPANISH_MEXICO,
    name: "Spanish (Mexico)",
    flag: "spain-mexico.svg"
  },
  {
    language: LANGUAGES.FRENCH,
    name: "French",
    flag: "france.svg"
  },
  {
    language: LANGUAGES.GERMAN,
    name: "German",
    flag: "germany.svg"
  },
  {
    language: LANGUAGES.ITALIAN,
    name: "Italian",
    flag: "italy.svg"
  },
  {
    language: LANGUAGES.PORTUGUESE,
    name: "Portuguese (Brazil)",
    flag: "brazil-portugal.svg"
  },
  {
    language: LANGUAGES.PORTUGUESE_PORTUGAL,
    name: "Portuguese (Portugal)",
    flag: "brazil-portugal.svg"
  },
  {
    language: LANGUAGES.HINDI,
    name: "Hindi",
    flag: "india.svg"
  },
  {
    language: LANGUAGES.TAMIL,
    name: "Tamil",
    flag: "india.svg"
  },
  {
    language: LANGUAGES.BENGALI,
    name: "Bengali",
    flag: "india.svg"
  },
  {
    language: LANGUAGES.POLISH,
    name: "Polish",
    flag: "poland.svg"
  },
  {
    language: LANGUAGES.JAPANESE,
    name: "Japanese",
    flag: "japan.svg"
  },
  {
    language: LANGUAGES.KOREAN,
    name: "Korean",
    flag: "korea.svg"
  },
  {
    language: LANGUAGES.CHINESE_SIMPLIFIED,
    name: "Mandarin (Chinese)",
    flag: "china.svg"
  },
  {
    language: LANGUAGES.CHINESE_CANTONESE,
    name: "Cantonese (Chinese)",
    flag: "china.svg"
  },
  {
    language: LANGUAGES.DUTCH,
    name: "Dutch",
    flag: "netherlands.svg"
  },
  {
    language: LANGUAGES.ARABIC,
    name: "Arabic",
    flag: "arabic.svg"
  },
  {
    language: LANGUAGES.FINNISH,
    name: "Finnish",
    flag: "finland.svg"
  },
  {
    language: LANGUAGES.RUSSIAN,
    name: "Russian",
    flag: "russia.svg"
  },
  {
    language: LANGUAGES.TURKISH,
    name: "Turkish",
    flag: "turkey.svg"
  },
  {
    language: LANGUAGES.VIETNAMESE,
    name: "Vietnamese",
    flag: "vietnam.svg"
  },
  {
    language: LANGUAGES.DANISH,
    name: "Danish",
    flag: "denmark.svg"
  },
  {
    language: LANGUAGES.INDONESIAN,
    name: "Indonesian",
    flag: "indonesia.svg"
  },
  {
    language: LANGUAGES.ROMANIAN,
    name: "Romanian",
    flag: "romania.svg"
  },
  {
    language: LANGUAGES.NORWEGIAN,
    name: "Norwegian (Bokmål)",
    flag: "norway.svg"
  },
  {
    language: LANGUAGES.NORWEGIAN_NORWAY,
    name: "Norwegian (Norway)",
    flag: "norway.svg"
  },
  {
    language: LANGUAGES.UKRAINIAN,
    name: "Ukrainian",
    flag: "ukraine.svg"
  },
  {
    language: LANGUAGES.FRENCH_CANADA,
    name: "French (Canada)",
    flag: "canada-france.svg"
  },
  {
    language: LANGUAGES.GERMAN_SWITZERLAND,
    name: "German (Switzerland)",
    flag: "germany.svg"
  },
  {
    language: LANGUAGES.CHINESE_TAIWAN,
    name: "Chinese (Taiwan)",
    flag: "taiwan.svg"
  },
  {
    language: LANGUAGES.SLOVAK_SLOVAKIA,
    name: "Slovak (Slovakia)",
    flag: "slovakia.svg"
  },
  {
    language: LANGUAGES.BULGARIAN_BULGARIA,
    name: "Bulgarian (Bulgaria)",
    flag: "bulgaria.svg"
  },
  {
    language: LANGUAGES.SWEDISH_SWEDEN,
    name: "Swedish (Sweden)",
    flag: "sweden.svg"
  },
  {
    language: LANGUAGES.CROATIAN_CROATIA,
    name: "Croatian (Croatia)",
    flag: "croatia.svg"
  },
  {
    language: LANGUAGES.GREEK_GREECE,
    name: "Greek (Greece)",
    flag: "greece.svg"
  },
  {
    language: LANGUAGES.KANNADA,
    name: "Kannada",
    flag: "india.svg"
  },
  {
    language: LANGUAGES.URDU,
    name: "Urdu",
    flag: "globe.svg"
  },
  {
    language: LANGUAGES.GUJARATI,
    name: "Gujarati",
    flag: "india.svg"
  },
  {
    language: LANGUAGES.MALAYALAM,
    name: "Malayalam",
    flag: "india.svg"
  },
  {
    language: LANGUAGES.PUNJABI,
    name: "Punjabi",
    flag: "india.svg"
  },
  {
    language: LANGUAGES.CZECH_CZECHIA,
    name: "Czech (Czechia)",
    flag: "czechia.svg"
  },
  {
    language: LANGUAGES.MALAY_MALAYSIA,
    name: "Malay (Malaysia)",
    flag: "malaysia.svg"
  },
  {
    language: LANGUAGES.HEBREW,
    name: "Hebrew",
    flag: "globe.svg"
  },
  {
    language: LANGUAGES.MARATHI,
    name: "Marathi",
    flag: "india.svg"
  },
  {
    language: LANGUAGES.TELUGU,
    name: "Telugu",
    flag: "india.svg"
  },
  {
    language: LANGUAGES.THAI_THAILAND,
    name: "Thai (Thailand)",
    flag: "thailand.svg"
  },
  {
    language: LANGUAGES.HUNGARIAN,
    name: "Hungarian",
    flag: "hungary.svg"
  },
  {
    language: LANGUAGES.FILIPINO_PHILIPPINES,
    name: "Filipino (Philippines)",
    flag: "globe.svg"
  },
  {
    language: LANGUAGES.ESTONIAN_ESTONIA,
    name: "Estonian (Estonia)",
    flag: "estonia.svg"
  },
  {
    language: LANGUAGES.HEBREW_ISRAEL,
    name: "Hebrew (Israel)",
    flag: "israel.svg"
  },
  {
    language: LANGUAGES.LATVIAN_LATVIA,
    name: "Latvian (Latvia)",
    flag: "latvia.svg"
  },
  {
    language: LANGUAGES.LITHUANIAN_LITHUANIA,
    name: "Lithuanian (Lithuania)",
    flag: "lithuania.svg"
  },
  {
    language: LANGUAGES.SERBIAN_SERBIA,
    name: "Serbian (Serbia)",
    flag: "serbia.svg"
  },
  {
    language: LANGUAGES.SLOVENIAN_SLOVENIA,
    name: "Slovenian (Slovenia)",
    flag: "slovenia.svg"
  },
  {
    language: LANGUAGES.SWAHILI_KENYA,
    name: "Swahili (Kenya)",
    flag: "kenya.svg"
  }
];

export const LanguageDataMap = convertArrayToMap(LanguageData, "language");

export const allowedTargetLanguages = LanguageData.filter(
  (lang) =>
    ![
      LANGUAGES.TAMIL,
      LANGUAGES.PORTUGUESE_PORTUGAL,
      LANGUAGES.CHINESE_CANTONESE
    ].includes(lang.language)
);
